import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=7040f96e&scoped=true&"
import script from "./AgentList.vue?vue&type=script&lang=ts&"
export * from "./AgentList.vue?vue&type=script&lang=ts&"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=7040f96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040f96e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
